var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTracks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "9c8wi72m4a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 0.780392 0 0 0 0 0.152941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -706) translate(444 706)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-444 -706) translate(444 706) translate(12 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EDF1F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E97FC",
    fillRule: "nonzero",
    d: "M25.389 28.703L25.204 32.018 24.965 36.551 20.873 41.262 9.375 41.262 9.375 22.738 20.847 22.738 20.873 22.711z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#9c8wi72m4a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00ABE9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77 11.643c0 1.697-.504 3.393-1.485 4.852L.058 15.036c.69-1.034 1.034-2.227 1.034-3.393 0-1.167-.345-2.36-1.034-3.394L2.285 6.79c.98 1.458 1.484 3.155 1.484 4.852zM14.375 11.643c0 3.738-1.114 7.477-3.288 10.738l-.583.901-2.2-1.485.583-.875c1.882-2.81 2.837-6.045 2.837-9.28 0-3.234-.955-6.469-2.837-9.279l-.584-.875L10.505.003l.583.902c2.175 3.26 3.288 7 3.288 10.738z",
    transform: "translate(40.25 20.375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.046 11.643c0 2.704-.77 5.409-2.36 7.795l-.583.901-2.227-1.485.61-.874c1.272-1.936 1.909-4.137 1.909-6.337s-.637-4.402-1.91-6.337l-.61-.875 2.228-1.485.583.902c1.59 2.386 2.36 5.09 2.36 7.795z",
    transform: "translate(40.25 20.375)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    fillRule: "nonzero",
    d: "M38.54 9.375L38.54 54.625 20.873 41.262 20.873 22.711z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTracks);
export default __webpack_public_path__ + "static/media/features-tracks.12afe2f3.svg";
export { ForwardRef as ReactComponent };